import { influencerlistService, jobCampaignsService } from "../../Services";
import { Modal } from "../../Components";
import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";

const AddMoreInfluencer = ({ open, close, listId, onSuccess }) => {
  const [sociaMediaList, setSociaMediaList] = useState([]);
  const [selectedPlatform, setSelectedPlatform] = useState("");
  const [handle, setHandle] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [progress, setProgress] = useState({ current: 0, total: 0 });

  const fetchData = async () => {
    try {
      const res = await jobCampaignsService.getSocialMedia();
      if (res.success === true) {
        const updatedPlatforms = res?.data.map(({ code, name, ...rest }) => ({
          value: code,
          label: name,
          ...rest,
        }));
        setSociaMediaList(updatedPlatforms);
        const instagram = updatedPlatforms.find(p => p.value === 'IG');
        if (instagram) {
          setSelectedPlatform(instagram.value);
        }
      }
    } catch (err) {
      console.log("🚀 ~ fetchData ~ err:", err);
      // addToast({
      //   error: true,
      //   msg: "Failed to load Data: " + (err.message || err),
      // });
    } finally {
    }
  };

  const handleAddMoreInfluencer = async () => {
    if (!selectedPlatform || !handle.trim()) {
      console.log("Please fill all required fields");
      return;
    }

    setIsSubmitting(true);
    try {
      const handles = handle
        .split(/[,\s]+/)
        .map((h) => h.trim())
        .filter((h) => h);
      setProgress({ current: 0, total: handles.length });
      for (let i = 0; i < handles.length; i++) {
        const params = {
          platform: selectedPlatform,
          handle: handles[i],
        };

        const res = await influencerlistService.addMoreInfluencer(
          listId,
          params
        );
        setProgress({ current: i + 1, total: handles.length });
      }

      console.log("All influencers added successfully");
      setSelectedPlatform("instagram");
      setHandle("");
      onSuccess?.();
      close();
    } catch (error) {
      console.log("Error adding influencer:", error);
    } finally {
      setIsSubmitting(false);
      setProgress({ current: 0, total: 0 });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (!open) return null;

  return (
    <Modal close={close}>
      <div className="relative w-full max-w-4xl max-h-[90vh] bg-white rounded-xl shadow-2xl outline-none overflow-hidden">
        <div className="bg-green-50 border-b border-green-200 p-4">
          <div className="text-xl font-semibold text-green-700">
            Add Influences
          </div>
        </div>

        <div className="py-6 px-6">
          <div className="mb-4">
            <label
              htmlFor="selectAccount"
              className="block text-green-700 text-sm font-medium my-2"
            >
              Select Platform <span className="text-red-500">*</span>
            </label>
            <select
              id="selectAccount"
              value={selectedPlatform}
              onChange={(e) => {
                setSelectedPlatform(e.target.value);
                const accountObj = sociaMediaList.find(
                  (platform) => platform.value === e.target.value
                );
                console.log("Selected account:", accountObj);
              }}
              disabled={isSubmitting}
              className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 mb-4"
            >
              <option value="">Choose an Platform...</option>
              {sociaMediaList.map((platform) => (
                <option key={platform.value} value={platform.value}>
                  {platform.label || "No Platform"}
                </option>
              ))}
            </select>

            <label
              htmlFor="applicationNote"
              className="block text-green-700 text-sm font-medium my-2"
            >
              Handle <span className="text-red-500">*</span>
            </label>
            <TextField
              id="handle"
              value={handle}
              onChange={(e) => setHandle(e.target.value)}
              placeholder="Please enter handle"
              multiline
              rows={5}
              fullWidth
              variant="outlined"
              className="w-full"
              disabled={isSubmitting}
            />
          </div>
        </div>

        <div className="px-6 py-4 bg-green-50 border-t border-green-200 flex justify-between items-center">
          <div className="flex items-center">
            {isSubmitting && (
              <>
                <div className="w-10 h-10 border-4 border-green-200 border-t-green-600 rounded-full animate-spin"></div>
                <span className="ml-3 text-green-700 font-medium">
                  Processing {progress.current} / {progress.total}
                </span>
              </>
            )}
          </div>
          <div>
            <button
              onClick={close}
              disabled={isSubmitting}
              className={`mr-2 rounded-full py-2 px-4 border text-green-700 border-green-300 hover:bg-green-100 transition-colors duration-200 ${
                isSubmitting ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              Cancel
            </button>

            <button
              onClick={handleAddMoreInfluencer}
              disabled={isSubmitting || !selectedPlatform || !handle.trim()}
              className={`rounded-full py-2 px-4 text-white bg-green-700 transition-colors duration-200 ${
                isSubmitting || !selectedPlatform || !handle.trim()
                  ? "opacity-50 cursor-not-allowed"
                  : "hover:bg-green-800"
              }`}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddMoreInfluencer;
